import { router } from '@inertiajs/react';

// Visits `url` replacing the current history entry, then announces it as the
// navigation it is. Inertia fires `navigate` only for push visits, and the app
// hangs GA4 page_view / native screen_view, the page_location re-pin and the
// plan-keyed re-identify off that event (entrypoints/inertia.jsx). A purchase
// landing must replace the paywall entry — Back would otherwise restore it with
// its stale, pre-purchase props — so it dispatches Inertia's documented global
// `inertia:navigate` event itself, exactly as a push visit would.
export function replaceVisit(url, { onSuccess } = {}) {
  router.visit(url, {
    replace: true,
    onSuccess: (page) => {
      document.dispatchEvent(
        new window.CustomEvent('inertia:navigate', { detail: { page } }),
      );
      onSuccess?.(page);
    },
  });
}
